<template>
  <div class="flex flex-col h-full">

    <div v-if="!hasInvoices && isLoading" class="flex flex-col w-full py-10 justify-center items-center gap-4">
      <Loader />
      <span>בודק את החבילה שלכם...</span>
    </div>
    <div v-else>
      <span>נראה שאין לכם חיבור לחשבוניות עדיין.</span>
    </div>

    <div class="w-full mt-auto flex flex-col gap-2">
      <Button
        label="בואו נתחיל"
        style="display: flex; flex-grow: 1"
        @click="$emit('next')"
      />
      <Button
        label="הקודם"
        outlined
        class=" w-full !rounded-3xl"
        style="display: flex; flex-grow: 1"
        @click="$emit('prev')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { SettingsApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';

const toast = useToast();

const emit = defineEmits(['next', 'prev']);

const isLoading = ref<boolean>(true);
const hasInvoices = ref<boolean>(false);

onMounted(() => {
  SettingsApi.validateInvoiceApp().then(res => {
    if (res.hasInvoices)
      emit('next');
  }).catch((err) => {
    console.log(err);
    toast.error('לא הצלחנו למצוא את החבילות שלכם. צרו איתנו קשר ונעזור!');
    emit('prev');
  }).finally(() => {
    isLoading.value = false;
  });
});

</script>

<style scoped lang="scss">
</style>
